module.exports = __webpack_public_path__ + "img/guide-btn-1.6e48bf8d.png";